import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomizableForm from 'components/shared/customizable-form';
import emailRegex from 'utils/emailRegex';
import MainHeader, {
  HeaderText,
  Underline,
} from 'components/shared/landing/main-header';
import styles from './styles.module.scss';

class LandingTemplate extends Component {
  /*
    Example props to demonstrate use
  */
  static defaultProps = {
    fields: {
      email: {
        validation: value => value && emailRegex.test(value),
        validationMessage:
          'Please check the format of your email and try again. ',
        label: {
          htmlFor: 'email',
          labelContent: 'Email',
        },
        input: {
          name: 'email',
          type: 'text',
          placeholder: 'Enter email here',
          className: 'form-control',
        },
      },
    },
    header: (
      <HeaderText>
        Valeria's <br />
        <Underline>Astronaut Summer Camp</Underline>
      </HeaderText>
    ),
    headerSubtext:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    formButtonText: 'Get Started',
    formTitle: 'Get Started Now',
    campaignName: "Valeria's Space Camp",
  };

  render() {
    const {
      fields,
      header,
      headerSubtext,
      formButtonText,
      formTitle,
      formTitleSubtext,
      price,
      discountPrice,
      campaignName,
    } = this.props;

    return (
      <div className="w-100">
        <div className={styles.headerContainer}>
          <MainHeader
            style={styles.mainBannerStyles}
            header={header}
            subtext={headerSubtext}
            subtextClassName="my-3 pr-1"
            form={
              <CustomizableForm
                buttonText={formButtonText}
                title={formTitle}
                titleSubtext={formTitleSubtext}
                fields={fields}
                price={price}
                discountPrice={discountPrice}
                campaignName={campaignName}
              />
            }
          />
        </div>
      </div>
    );
  }
}

LandingTemplate.propTypes = {
  fields: PropTypes.shape({
    input: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      placeholder: PropTypes.string,
      className: PropTypes.string,
    }),
    label: PropTypes.shape({
      htmlFor: PropTypes.string,
      labelContent: PropTypes.string,
    }),
  }),
  header: PropTypes.element,
  headerSubtext: PropTypes.string,
  formButtonText: PropTypes.string,
  formTitle: PropTypes.string,
  campaignName: PropTypes.string,
};

export default LandingTemplate;
